import React, { Component } from 'react'
import logo from "../img/logo.png";

class Career extends Component {
  render() {
    return (
      <>
        <footer>
          <div className="container">
            <div className="copyright">
              <div>
                <a href="!#">
                  <img className="footer-logo" src={logo} alt="logo" />
                </a>
              </div>
              <span>© 2020 Neelam Design</span>
            </div>
            <div>
              <h1>About us</h1>
              <ul>
                <li>
                  <a href="!#">WHO WE ARE</a>
                </li>
                <li>
                  <a href="!#">CONTACT US</a>
                </li>
                <li>
                  <a href="!#">FAQs</a>
                </li>
                <li>
                  <a href="!#">MISSIONS</a>
                </li>
                <li>
                  <a href="!#">OTHER COMPANIES</a>
                </li>
              </ul>
            </div>
            <div>
              <h1>Company</h1>
              <ul>
                <li>
                  <a href="!#">CAREERS</a>
                </li>
                <li>
                  <a href="!#">LEGAL</a>
                </li>
                <li>
                  <a href="!#">POLICY</a>
                </li>
                <li>
                  <a href="!#">PRESS</a>
                </li>
                <li>
                  <a href="!#">BLOG</a>
                </li>
              </ul>
            </div>
            <div className="socials">
              <div className="footer-socials">
                <h1>Socials</h1>
                <div className="ui column icon">
                  <div className="ui vertical social icon">
                    <a className="item footer-socials" href="!#">
                      <i className="facebook f icon" />
                    </a>
                    <a className="item footer-socials" href="!#">
                      <i className="tumblr icon" />
                    </a>
                    <a className="item footer-socials" href="!#">
                      <i className="instagram icon" />
                    </a>
                    <a className="item footer-socials" href="!#">
                      <i className="youtube icon" />
                    </a>
                  </div>
                </div>   
              </div>
            </div>
          </div>
        </footer>
      </>
    )
  }
}

export default Career
